import { render, staticRenderFns } from "./VariableGroup.vue?vue&type=template&id=22576606"
import script from "./VariableGroup.vue?vue&type=script&lang=js"
export * from "./VariableGroup.vue?vue&type=script&lang=js"
import style0 from "./VariableGroup.vue?vue&type=style&index=0&id=22576606&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports